import React from "react";

import styles from "./index.module.css";

import WPImage from "../../atoms/WPImage";
import GifAnimation from "../../atoms/GifAnimation";
import withSection from "../withSection";
import GoogleMaps from "../../atoms/GoogleMaps";
import { sectionScale, checkIsPC } from "../../atoms";
import useDims from "../../atoms/useDims";

import discoball from "../../../assets/disco/disco.png";
import { textAnimation, titleAnimation, FEED_URL } from "../../../constants";

const Description = ({ value, ...props }) => {
  const stripSpace = s => s.replace(/\s/g, "");
  const cleaned = value
    ? value.split("\n").map(arr => {
        const spaces = arr.match(/\s/g);
        if (spaces && spaces.length === arr.length) {
          return stripSpace(arr).trim();
        } else {
          return arr.trim();
        }
      })
    : [];
  return (
    <div {...props}>
      {cleaned.map((v, i) => (
        <GifAnimation key={`${v}-${i}`} gifSrc={textAnimation()} noHover>
          <p className={styles.sentence}>
            {v}
            <br />
          </p>
        </GifAnimation>
      ))}
    </div>
  );
};

const About = ({ data, lang = "en" }) => {
  const MAX_WIDTH = 400;
  const result = (data && data.acf) || {};
  const output = key => result[key + "_" + lang];

  const { width } = useDims({
    height: window.innerHeight,
    width: window.innerWidth
  });

  const isPC = checkIsPC(width);
  const scaledPadding = (60 * 1) / sectionScale(window.innerWidth);
  const paddingLeft = isPC ? scaledPadding : 0;

  console.log(result);

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <Description
          className={styles.description}
          style={{ width: width, maxWidth: MAX_WIDTH }}
          value={output("description")}
          readOnly
        />

        <div style={{ width: isPC ? 591 : "100%" }}>
          <WPImage
            className={styles.teamImage}
            data={result.photo}
            alt="disco team"
          />
        </div>

        <div className={styles.discoball}>
          <a href={result.instagram_link || "/"}>
            <img src={discoball} height={60} alt="disco ball" />
          </a>
        </div>
      </div>

      <div className={styles.right} style={{ paddingLeft: paddingLeft }}>
        <div>
          <GifAnimation gifSrc={titleAnimation()} noHover>
            <h2 className={`${styles.title} ${styles.contact}`}>CONTACT</h2>
          </GifAnimation>
          <GoogleMaps />

          <div className={styles.contactContainer}>
            <GifAnimation gifSrc={textAnimation()} noHover>
              <a href={`mailto:${result.email}`} className={styles.email}>
                {result.email}
              </a>
            </GifAnimation>
            <GifAnimation gifSrc={textAnimation()} noHover>
              <a
                href={"https://goo.gl/maps/dw2Yh7yTwDPi9dQg6"}
                className={styles.address}
                target="_blank"
                rel="noreferrer noopener"
              >
                <p>{output("address")}</p>
              </a>
            </GifAnimation>
          </div>
        </div>

        <div className={styles.recruitContainer}>
          <GifAnimation gifSrc={titleAnimation()} noHover>
            <h2 className={styles.title}>RECRUIT</h2>
          </GifAnimation>
          <a
            className={styles.recruitmentLink}
            href={result.recruitment_link}
            target="_blank"
            rel="noreferrer noopener"
          >
            <GifAnimation gifSrc={textAnimation()} noHover>
              <p className={styles.recruitmentText}>
                join us. we have cookies.
              </p>
            </GifAnimation>
          </a>
        </div>
      </div>
    </div>
  );
};

export default withSection(About);
